export default "__VITE_ASSET__kzvJp2SHYBS_Ak6CuhUW5A__"